export const providerConsents = {
    // ==========================================
    // Common providers (used across QA, UAT, PROD)
    // ==========================================
    'semyazdorovie-gomel': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'lubimydoctor-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'tomography-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=tomography-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=tomography-minsk',
    },
    'aclinica-mogilev': { // Note: QA had a typo 'aclinica-mogilevl' in providerCode, using the code from baseUrl instead
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=aclinica-mogilev',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=aclinica-mogilev',
    },
    'babyboss-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=babyboss-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=babyboss-minsk',
    },
    'alphamed-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },

    // ==========================================
    // Providers mostly used in QA / UAT
    // ==========================================
    'lode-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'lode-grodno': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'lode-brest': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'horizont2-minsk': {
        onlineBookingLink: 'https://horizont/onlineBookingLink',
        onlineBookingChildLink: 'https://horizont/onlineBookingChildLink',
    },

    // ==========================================
    // PROD providers
    // ==========================================
    'boli-v-spine': { // Extracted from config key, because baseUrl is different (/api/online)
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'kravira-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=kravira-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=kravira-minsk',
    },
    'grandmedica-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'medpractika-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'proudclinic-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'amadei-gomel': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'unimed-borisov': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'belsono-belarus': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'anatomiya-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'profimed-lida': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'aksamit-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'gravita-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'grantimed-okomedson-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'vinci-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'lifecity-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'vnuki-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'sevenmed-gomel': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'doctortut-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=doctortut-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=doctortut-minsk',
    },
    'novolekar-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'sportmedneo-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'womenhealth-grodno': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'eleos-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'tari-bobruysk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'garmonya-belarus': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'medicplus-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'butterfly-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'lini-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'medart-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'forestmed-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'zdorovogosna-brest': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'zdorovogosna2-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'eclinic-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'genez-mogilev': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'supramed-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'gtfmir-grodno': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'medstyle-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'kaskad-minsk': {
        onlineBookingLink: 'https://aibolit.by/online-booking-clinic?pc=kaskad-minsk',
        onlineBookingChildLink: 'https://aibolit.by/online-booking-child-clinic?pc=kaskad-minsk',
    },
    'expert-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'mako-borisov': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'veanmar-grodno': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'medikus-zhodino': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'glazkov-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'pediatria-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'elicato-gomel': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'femineclinic-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'luxestetic-gomel': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'antesmed-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'sportlab-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'lfkano-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'aclinic-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'emiclinic-gomel': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'homoeopathy-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'biovin-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'simed-rechytsa': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'maivamed-vitebsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'restart-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'egodent-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
    'vokadent-minsk': {
        onlineBookingLink: '',
        onlineBookingChildLink: '',
    },
};
